import React, { useContext } from "react";

import TimeTableContext from "../../../context/timeTableContext";

import FilterListIcon from "@material-ui/icons/FilterList";

function FrontLessons(props) {
  const context = useContext(TimeTableContext);
  return (
    <div className="table-holder">
      <table class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th
              onClick={() =>
                context.dispatch({
                  type: "SORT_BY",
                  payload: { arrName: "currentTimeInfo", field: "class" },
                })
              }
            >
              כיתה <FilterListIcon style={{ fontSize: 12 }} />
            </th>
            <th
              onClick={() =>
                context.dispatch({
                  type: "SORT_BY",
                  payload: { arrName: "currentTimeInfo", field: "subject" },
                })
              }
            >
              מקצוע <FilterListIcon style={{ fontSize: 12 }} />
            </th>
            <th
              onClick={() =>
                context.dispatch({
                  type: "SORT_BY",
                  payload: { arrName: "currentTimeInfo", field: "teachers" },
                })
              }
            >
              מורה <FilterListIcon style={{ fontSize: 12 }} />
            </th>
          </tr>
        </thead>
        <tbody>
          {context.state.currentTimeInfo.map((lessons) => {
            if (lessons != undefined) {
              return (
                <tr>
                  <td>{lessons.class}</td>
                  <td>{lessons.subject}</td>
                  <td>{lessons.teachers}</td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
    </div>
  );
}

export default FrontLessons;
